import type React from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useCardTelemetry } from '@apps/card/Card.telemetry';
import { useDesignGalleryFiltersContext } from '../../DesignGalleryFiltersProvider';
import type { FacetClickSource } from './Filter.types';

const isValidFacetSource = (source: string | undefined): source is FacetClickSource => !!source && ['mobileDrawer', 'desktopDropdown'].includes(source);

/**
 * Shared `onChange` handler for filter facet checkboxes. Logs telemetry and toggles the active
 * filter. Used by both the primary filter row and the overflow row so they behave identically.
 */
export const useFilterChangeHandler = () => {
  const { buttonInteracted } = useCardTelemetry();
  const { setActiveFilter } = useDesignGalleryFiltersContext();

  return useEventCallback<React.ChangeEventHandler<HTMLInputElement>>(evt => {
    const { target } = evt;

    if (!target.disabled && target.dataset.itemId && isValidFacetSource(target.dataset.source)) {
      buttonInteracted({ name: 'designsGallery_filterFacetClicked', facet: 'format', source: target.dataset.source, code: target.dataset.itemId, isChecked: target.checked });
      setActiveFilter(target.dataset.itemId, target.checked);
    }
  });
};
